import { cn } from "@/lib/utils";

export function BreadcrumbHeader({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "mb-6 grid grid-cols-1 gap-4 md:mb-3 md:grid-cols-[1fr_auto] print:hidden",
        className,
      )}
    >
      {children}
    </div>
  );
}
